import SurveyBackgroundLayout from '@/components/layout/SurveyBackgroundLayout';
import { SurveyContentPanel, SurveyContentPanelInset } from '@/components/layout/SurveyContentPanel';
import { QrCode } from 'lucide-react';

export default function StaffRequired() {
  return (
    <SurveyBackgroundLayout>
      <div className="absolute z-10 inset-x-0 top-[18%] flex flex-col items-center px-6 text-center">
        <div className="mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-white/20 backdrop-blur-sm">
          <QrCode className="h-10 w-10 text-white" strokeWidth={1.5} />
        </div>
        <h1 className="text-[28px] font-bold leading-tight text-white drop-shadow-[0_2px_8px_rgba(0,0,0,0.4)] sm:text-[32px]">
          Scan promoter QR
        </h1>
        <p className="mt-2 text-[18px] font-bold text-white/90">Imbas kod QR promoter</p>
      </div>

      <div className="absolute z-10 inset-x-0 top-[42%]">
        <SurveyContentPanelInset>
          <SurveyContentPanel className="!py-8">
            <p className="m-0 text-center leading-snug">
              Please scan the QR code shown by your LD sales promoter to start the survey.
            </p>
            <p className="m-0 mt-[1lh] text-center leading-snug">
              Sila imbas kod QR yang ditunjukkan oleh promoter jualan LD anda untuk memulakan tinjauan
              ini.
            </p>
          </SurveyContentPanel>
        </SurveyContentPanelInset>
      </div>
    </SurveyBackgroundLayout>
  );
}
